module.exports = __webpack_public_path__ + "static/img/bcg.2a5ffa33.jpg";